import { Environment } from "@coxauto-ui/cxm/communications/interfaces";
import { HttpRequest, fetchWrapper } from "@coxauto-ui/core-http";
import { getBaseUrl, getHeader } from "../config";
import { GetStationeryByIdRequest } from "./interfaces/get-stationery";

export async function getStationeryById(
  data: GetStationeryByIdRequest,
  env: Environment
): Promise<string> {
  const url = `${getBaseUrl(env)}cxm/stationery/html?stationeryId=${
    data.stationeryId
  }&vinDealerId=${data.dealerId}`;
  const header = await getHeader();

  const request: HttpRequest = {
    url,
    method: "GET",
    headers: header
  };

  const response = await fetchWrapper.sendAsyncText(request);

  if (response && response.data && !response.hasError) {
    return response.data;
  } else {
    console.warn(
      `Error fetching stationery HTML for stationeryId: ${data.stationeryId}, dealerId: ${data.dealerId}`,
      response?.error
    );
    return ""; // Return empty response on error
  }
}
